import React, { useContext, useEffect, useState } from 'react';
import Modal from '../UI/Modal';
import Button from '../UI/Button';
import * as resumeService from '../../services/resumeService';
import * as aiService from '../../services/aiService';
import { AuthContext } from '../../context/AuthContext';
import { toast } from 'react-toastify';

export default function JobMatchModal({ isOpen, onClose, jobId, job }) {
	const { credits, updateCredits } = useContext(AuthContext);
	const [resumes, setResumes] = useState([]);
	const [selected, setSelected] = useState('');
	const [loading, setLoading] = useState(false);
	const [result, setResult] = useState(null);

	useEffect(() => {
		if (!isOpen) return;
		(async () => {
			try {
				const r = await resumeService.getAllResumes(1, 100);
				setResumes(r.resumes || []);
			} catch {
			}
		})();
	}, [isOpen]);

	async function handleMatch() {
		if (!selected) {
			toast.error('Select a resume');
			return;
		}
		if (credits < 2) {
			toast.error('Insufficient credits');
			return;
		}
		setLoading(true);
		try {
			const res = await aiService.matchJob(selected, job?.description || '');
			setResult(res.analysis || res);
			await updateCredits();
		} catch (e) {
			toast.error('Match failed');
		} finally {
			setLoading(false);
		}
	}

	return (
		<Modal isOpen={isOpen} onClose={onClose} title="Match My Resume">
			<div className="space-y-3">
				<select className="w-full border rounded px-3 py-2" value={selected} onChange={(e) => setSelected(e.target.value)}>
					<option value="">Select resume</option>
					{resumes.map((r) => (
						<option key={r._id} value={r._id}>
							{r.title}
						</option>
					))}
				</select>
				<Button onClick={handleMatch} disabled={loading || credits < 2}>
					{loading ? 'Analyzing...' : 'Match'}
				</Button>
				{result && (
					<div className="border rounded p-3 text-sm">
						<p className="font-semibold">Match: {result.matchPercentage || 0}%</p>
						<p className="mt-1">
							<strong>Top Matches:</strong> {(result.matchingKeywords || []).slice(0, 5).join(', ')}
						</p>
						<p className="mt-1">
							<strong>Top Gaps:</strong> {(result.missingKeywords || []).slice(0, 5).join(', ')}
						</p>
						<div className="mt-2 flex items-center gap-2">
							<Button variant="ghost" onClick={() => toast.info('Opening full analysis')}>
								View Full Analysis
							</Button>
							<Button variant="ghost" onClick={() => toast.info('Opening resume editor')}>
								Update Resume
							</Button>
							<Button variant="ghost" onClick={() => toast.info('Redirecting to apply')}>
								Apply Now
							</Button>
						</div>
					</div>
				)}
			</div>
		</Modal>
	);
}


